import React from 'react';

const TariffSettings = ({ formData, handleChange }) => {
  return (
    <div className="card">
      <div className="card-body">
        <h3 style={{ marginBottom: '1.5rem', fontSize: '1.25rem', fontWeight: 600 }}>
          💰 Tarifeler ve Ücretler
        </h3>
        
        {/* Mesai Ücreti */}
        <div style={{ marginBottom: '2rem' }}>
          <h4 style={{ color: '#0369a1', marginBottom: '1rem' }}>Mesai Yolluk Ücreti</h4>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Mesai Yolluk (TRY)</label>
              <input
                type="number"
                step="0.01"
                className="form-input"
                value={formData.overtime_fee_try}
                onChange={(e) => handleChange('overtime_fee_try', parseFloat(e.target.value) || 0)}
              />
            </div>
          </div>
        </div>

        {/* HSSGM Tahakkuku */}
        <div style={{ marginBottom: '2rem', padding: '1.5rem', background: '#f0f9ff', borderRadius: '8px' }}>
          <h4 style={{ color: '#0369a1', marginBottom: '1rem' }}>HSSGM Tahakkuku (Sanitary Dues) - TL/NRT</h4>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">a) Tam (Ticari)</label>
              <input
                type="number"
                step="0.01"
                className="form-input"
                value={formData.hssgm_commercial}
                onChange={(e) => handleChange('hssgm_commercial', parseFloat(e.target.value) || 0)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">b) Kabotaj (50-250 NT)</label>
              <input
                type="number"
                step="0.01"
                className="form-input"
                value={formData.hssgm_cabotage_small}
                onChange={(e) => handleChange('hssgm_cabotage_small', parseFloat(e.target.value) || 0)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">c) Kabotaj (251+ NT)</label>
              <input
                type="number"
                step="0.01"
                className="form-input"
                value={formData.hssgm_cabotage_large}
                onChange={(e) => handleChange('hssgm_cabotage_large', parseFloat(e.target.value) || 0)}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">d) Özel Yat</label>
              <input
                type="number"
                step="0.01"
                className="form-input"
                value={formData.hssgm_private_yacht}
                onChange={(e) => handleChange('hssgm_private_yacht', parseFloat(e.target.value) || 0)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">e) Turist Gemisi</label>
              <input
                type="number"
                step="0.01"
                className="form-input"
                value={formData.hssgm_tourist_ship}
                onChange={(e) => handleChange('hssgm_tourist_ship', parseFloat(e.target.value) || 0)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">f) Araştırma Gemisi</label>
              <input
                type="number"
                step="0.01"
                className="form-input"
                value={formData.hssgm_research_ship}
                onChange={(e) => handleChange('hssgm_research_ship', parseFloat(e.target.value) || 0)}
              />
            </div>
          </div>
        </div>

        {/* Fener Ücreti - Yabancı */}
        <div style={{ marginBottom: '2rem', padding: '1.5rem', background: '#fef3c7', borderRadius: '8px' }}>
          <h4 style={{ color: '#b45309', marginBottom: '1rem' }}>Kıyı Emniyeti Fener Ücreti (Light Dues) - USD/NT - Yabancı</h4>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Ticaret (0-800 NT)</label>
              <input
                type="number"
                step="0.00001"
                className="form-input"
                value={formData.light_dues_foreign_commercial_0_800}
                onChange={(e) => handleChange('light_dues_foreign_commercial_0_800', parseFloat(e.target.value) || 0)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Ticaret (800+ NT)</label>
              <input
                type="number"
                step="0.00001"
                className="form-input"
                value={formData.light_dues_foreign_commercial_800_plus}
                onChange={(e) => handleChange('light_dues_foreign_commercial_800_plus', parseFloat(e.target.value) || 0)}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Yolcu (0-800 NT)</label>
              <input
                type="number"
                step="0.00001"
                className="form-input"
                value={formData.light_dues_foreign_passenger_0_800}
                onChange={(e) => handleChange('light_dues_foreign_passenger_0_800', parseFloat(e.target.value) || 0)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Yolcu (800+ NT)</label>
              <input
                type="number"
                step="0.00001"
                className="form-input"
                value={formData.light_dues_foreign_passenger_800_plus}
                onChange={(e) => handleChange('light_dues_foreign_passenger_800_plus', parseFloat(e.target.value) || 0)}
              />
            </div>
          </div>
        </div>

        {/* Fener Ücreti - Türk */}
        <div style={{ marginBottom: '2rem', padding: '1.5rem', background: '#dcfce7', borderRadius: '8px' }}>
          <h4 style={{ color: '#16a34a', marginBottom: '1rem' }}>Kıyı Emniyeti Fener Ücreti - Türk Bayraklı</h4>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Türk (0-800 NT)</label>
              <input
                type="number"
                step="0.00001"
                className="form-input"
                value={formData.light_dues_turkish_0_800}
                onChange={(e) => handleChange('light_dues_turkish_0_800', parseFloat(e.target.value) || 0)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Türk (800+ NT)</label>
              <input
                type="number"
                step="0.00001"
                className="form-input"
                value={formData.light_dues_turkish_800_plus}
                onChange={(e) => handleChange('light_dues_turkish_800_plus', parseFloat(e.target.value) || 0)}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Kabotaj (0-800 NT)</label>
              <input
                type="number"
                step="0.00001"
                className="form-input"
                value={formData.light_dues_turkish_cabotage_0_800}
                onChange={(e) => handleChange('light_dues_turkish_cabotage_0_800', parseFloat(e.target.value) || 0)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Kabotaj (800+ NT)</label>
              <input
                type="number"
                step="0.00001"
                className="form-input"
                value={formData.light_dues_turkish_cabotage_800_plus}
                onChange={(e) => handleChange('light_dues_turkish_cabotage_800_plus', parseFloat(e.target.value) || 0)}
              />
            </div>
          </div>
        </div>

        {/* DTO Ücretleri */}
        <div style={{ padding: '1.5rem', background: '#f3e8ff', borderRadius: '8px' }}>
          <h4 style={{ color: '#7c3aed', marginBottom: '1rem' }}>DTO (Deniz Ticaret Odası) Ücretleri - TRY</h4>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Liman Hizmeti (Türk)</label>
              <input
                type="number"
                step="0.01"
                className="form-input"
                value={formData.dto_port_service_turkish}
                onChange={(e) => handleChange('dto_port_service_turkish', parseFloat(e.target.value) || 0)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Liman Hizmeti (Yabancı)</label>
              <input
                type="number"
                step="0.01"
                className="form-input"
                value={formData.dto_port_service_foreign}
                onChange={(e) => handleChange('dto_port_service_foreign', parseFloat(e.target.value) || 0)}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Yük Navlun (Tekli)</label>
              <input
                type="number"
                step="0.01"
                className="form-input"
                value={formData.dto_freight_container_single}
                onChange={(e) => handleChange('dto_freight_container_single', parseFloat(e.target.value) || 0)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Yük Navlun (Kombine)</label>
              <input
                type="number"
                step="0.01"
                className="form-input"
                value={formData.dto_freight_container_combined}
                onChange={(e) => handleChange('dto_freight_container_combined', parseFloat(e.target.value) || 0)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TariffSettings;
